import React, {useContext, useState, useEffect} from 'react';
import './Groups.css';
import axios from 'axios';
import config from '../../../config';
import { AuthContext } from '../../../contexts/authContext';
import { EditIcon, TrashIcon, AddIcon, CachedIcon } from '../../../assets/icons/icons';
import { IconButton } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT } from '@mui/x-data-grid/locales';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';
import {
    DataGridPremium
} from '@mui/x-data-grid-premium';
import ManageGroupsDialog from './ManageGroupsDialog';
import DeleteGroupsDialog from './DeleteGroupsDialog';
import { LicenseInfo } from '@mui/x-license';
import useNotification from '../../../hooks/useNotification';

LicenseInfo.setLicenseKey(config.MUI_DATA_GRID_PREMIUM_LICENSE);

const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
    },
    itIT,
);

const ActionCell = (params, openDialog, openDeleteDialog) => {
    return(
        <div>
            <IconButton onClick={() => openDialog('mod')} size='small' >
                <EditIcon addClass='pointer'></EditIcon>
            </IconButton>
            <IconButton onClick={openDeleteDialog} size='small'>
                <TrashIcon addClass="pointer" ></TrashIcon>
            </IconButton>
        </div>
    )
}

const ActionHeaderCell = (params, openDialog, getTags, getGroups) => {
    return(
        <div className="centered-cell" >
            <IconButton title='Ricarica dati' onClick={() => {getTags(); getGroups()}} size='small' >
                <CachedIcon addClass='pointer'/>
            </IconButton>
            <IconButton onClick={() => openDialog('ins')} size='small' title='Inserisci Fermata' >
                <AddIcon addClass='pointer'/>
            </IconButton>
        </div>
    )
}

function Groups(props) {
    const auth = useContext(AuthContext);
    const { groups, setGroups, tags, setTags } = useContext(AppAuthGlobalVariables);
    const { notificationError } = useNotification();

    const [loading, setLoading] = useState(true);
    const [groupsLoading, setGroupsLoading] = useState(true);

    const [tagsAutocomplete, setTagsAutocomplete] = useState([]);

    const [openManageGroupsDialog, setOpenManageGroupsDialog] = useState(false);
    const [openDeleteGroupsDialog, setOpenDeleteGroupsDialog] = useState(false);
    const [lastCellData, setLastCellData] = useState(null);

    const columns = [
        {field: 'ACTION', headerClassName: 'header-cell action-cell', headerName: '', type: 'string', width: 100, align: 'center', headerAlign: 'center', disableColumnMenu: true, sortable: false, disableExport: true, renderHeader: (params) => ActionHeaderCell(params, handleOpenManageGroupsDialog, getTags, getGroups), renderCell: (params) => ActionCell(params, handleOpenManageGroupsDialog, handleOpenDeleteGroupsDialog)},
        /* {field: 'idEntita', headerClassName: 'header-cell id', headerName: 'Numero Fermata', type: 'string', width: 150, align: 'right', headerAlign: 'right', valueGetter: (params) => params?.S}, */
        {field: 'descrizione', headerClassName: 'header-cell descrizione', headerName: 'Descrizione', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.S},
        //{field: 'tagList', headerClassName: 'header-cell tagList', headerName: 'Tag associati', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.SS?.join(', ') || ''},
    ]

    useEffect(() => {
        if(!groups.length || !tags.length){
            getGroups();
            getTags();
        }else{
            convertTagsForAutocomplete(tags)
            setGroupsLoading(false);
            setLoading(false);
        }
    }, [])

    useEffect(() => {
        if(!loading){
            getGroups();
            getTags();
        }
    }, [props.city])

    const getGroups = async() => {
        try {
            setLoading(true);
            setGroupsLoading(true);

            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-groups',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            setGroups(response.data.dataToReturn);
            //setRows(response.data.dataToReturn);
            setGroupsLoading(false);
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setGroupsLoading(false);
            setLoading(false);
        }
    }

    const getTags = async() => {
        try {
            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-tags',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            const allTags = response.data.dataToReturn;
            
            setTags(allTags);
            convertTagsForAutocomplete(allTags);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    const convertTagsForAutocomplete = (list) => {
        let copyList = [...list] || [];
        for (let index = 0; index < copyList.length; index++) {
            let element = copyList[index];
            
            let newElement = {
                id: element?.idEntita?.S,
                label: element?.descrizione?.S || ''
            };
            copyList[index] = newElement;
        }

        setTagsAutocomplete(copyList);
    }

    const handleOpenManageGroupsDialog = (action) => {
        setOpenManageGroupsDialog(action)
    }
    const handleCloseManageGroupsDialog = () => {
        setOpenManageGroupsDialog(false);
    }

    const handleOpenDeleteGroupsDialog = () => {
        setOpenDeleteGroupsDialog(true);
    }   
    const handleCloseDeleteGroupsDialog = () => {
        setOpenDeleteGroupsDialog(false);
    }

    return (
        <div className='component-container groups'>
            <div className='component-card'>
                <ThemeProvider theme={theme}>
                    <DataGridPremium
                        rows={groups}
                        columns={columns}
                        className="groups-table"
                        loading={groupsLoading}
                        rowHeight={30}
                        onCellClick={(params) => setLastCellData(params.row)}
                        getRowId={(row) => row.idEntita.S}
                        disableAggregation
                        disableRowGrouping
                        disableDensitySelector
                        //slots={{
                        //    toolbar: ()=>CustomToolbar(),
                        //}}
                    />
                </ThemeProvider>
            </div>
            <ManageGroupsDialog {...{
                openManageGroupsDialog,
                handleCloseManageGroupsDialog,
                lastCellData,
                getGroups,
                tags: tagsAutocomplete,
                city: props.city
            }}/>
            <DeleteGroupsDialog {...{
                openDeleteGroupsDialog,
                handleCloseDeleteGroupsDialog,
                lastCellData,
                getGroups
            }}/>
        </div>
    )
}

export default Groups